import { NgModule } from '@angular/core'; 
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SitioPublicoRuteoModule } from './sitio-publico-ruteo.module';
import { ComunesModule} from '../modulo-comunes/comunes.module';

import { SitioPublicoComponent } from './sitio-publico.component';
import { TopBarComponent } from './componentes/top-bar/top-bar.component';
import { FooterComponent } from './componentes/footer/footer.component';
import { InicioComponent } from './componentes/inicio/inicio.component';
import { IngresoComponent } from './componentes/ingreso/ingreso.component';
import { NuevoUsrComponent } from './componentes/nuevo-usr/nuevo-usr.component';
import { NuevaEmpComponent } from './componentes/nueva-emp/nueva-emp.component';
import { PedirAccesoEmpComponent } from './componentes/pedir-acc-emp/pedir-acc-emp.component';
import { CambioPwdComponent } from './componentes/cambio-pwd/cambio-pwd.component';
import { TerminosUsoComponent } from './componentes/terminos-uso/terminos-uso.component';

@NgModule({
  imports: [ 
    CommonModule,
    ReactiveFormsModule,
    SitioPublicoRuteoModule,
    ComunesModule
  ],
  declarations: [ 
    SitioPublicoComponent,
    TopBarComponent, 
    FooterComponent,
    InicioComponent,
    IngresoComponent, 
    NuevoUsrComponent,
    NuevaEmpComponent,
    PedirAccesoEmpComponent,
    CambioPwdComponent,
    TerminosUsoComponent
  ]
})
export class SitioPublicoModule { }
